import { render, staticRenderFns } from "./ProductSkuList.vue?vue&type=template&id=15785941&scoped=true&"
import script from "./ProductSkuList.vue?vue&type=script&lang=js&"
export * from "./ProductSkuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15785941",
  null
  
)

export default component.exports